// mis-facturas.controller.js
/* globals angular */
"use strict";

class historicoFacturasController {
  constructor(historicoFacturasService, $filter, $window, $document) {
    this.$window = $window;
    this.$document = $document;
    this.service = historicoFacturasService;
    this.$filter = $filter;
    this.listadoFacturas = [];
    this.listadoFacturasaPagar = [];
    this.mostrarListadoDePago = false;
    this.totalFacturasaPagar = 0;
    this.propertyName = 'billingDate';
    this.reverse = true;
    this.literalesEstados={
      'Pendiente': 'En proceso',
      'Pendiente Cobro': 'Enviada al banco',
      'Pagada': 'Pagada',
      'Impagada': 'Impagada',
      'Pagada Parcialmente': 'Pagada parcialmente',
      'Compensada': 'Compensada',
      'Negociada': 'Negociada',
      'Abonada': 'Abonada'
     };

    this.clasesEstados={
      'Pendiente': 'pagada',
      'Pendiente Cobro': 'pagada',
      'Pagada': 'pagada',
      'Impagada': 'pendiente',
      'Pagada Parcialmente': 'pendiente',
      'Compensada': 'compensada',
      'Negociada': 'pendiente',
      'Abonada': 'pagada'
    };
  }

  $onInit() {

  }

  ocultarPagos(){
      this.totalFacturasaPagar = 0;
      this.listadoFacturasaPagar = [];
      this.mostrarListadoDePago=false;
  }

  seleccionFactura(id){

    if(!this.mostrarListadoDePago){
      this.totalFacturasaPagar = 0;
      this.listadoFacturasaPagar = [];
      this.mostrarListadoDePago = true;
    }

    if(this.listadoFacturasaPagar.indexOf(id)!=-1){
      var index = this.listadoFacturasaPagar.indexOf(id);
      this.listadoFacturasaPagar.splice(index, 1);
    }else{
      this.listadoFacturasaPagar.push(id);
    }

    this.totalFacturasaPagar = 0;

    this.listadoFacturas.forEach(element => {
      if(this.listadoFacturasaPagar.indexOf(element.id)!=-1){
        this.totalFacturasaPagar = this.totalFacturasaPagar + element.unpaid_amount;
      }
    });
  }

  hayFactSelect(){
    if(this.totalFacturasaPagar == 0){
      return false;
    }else{
      return true;
    }
  }

  estaSeleccionado(id){
    if(this.listadoFacturasaPagar.indexOf(id)!=-1){
      return true;
    }else{
      return false;
    }
  }

  efectuarPago(){

    var orderData = JSON.stringify(this.listadoFacturasaPagar);
    var dt = new Date();
    var padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
    var orderID = `${
        padL(dt.getMonth()+1)}${
        padL(dt.getDate())}${
        dt.getFullYear().toString().substring(2)}${
        padL(dt.getHours())}${
        padL(dt.getMinutes())}${
        padL(dt.getSeconds())}`;

    var orderAmount = this.totalFacturasaPagar * 100;

    this
    .service
    .payBilling(orderID, orderAmount, orderData, this.direccionId, this.year)
    .then(result=>{
      document.getElementById('Ds_SignatureVersion').value = result.Ds_SignatureVersion;
      document.getElementById('Ds_MerchantParameters').value = result.Ds_MerchantParameters;
      document.getElementById('Ds_Signature').value = result.Ds_Signature;
      document.getElementById('formPago').setAttribute('action', result.redsysURL);
      document.getElementById('formPago').submit();
      document.getElementById('Ds_SignatureVersion').value = "";
      document.getElementById('Ds_MerchantParameters').value = "";
      document.getElementById('Ds_Signature').value = "";
      document.getElementById('formPago').setAttribute('action', '#');

    });
  }

  download(invoice, data) {
    this.limpiarMensajes();
    const filename = "Factura Energía El Corte Inglés " + this.$filter('date')(data.billingDate, 'yyyyMMdd') + ".pdf";
    this
    .service
    .download(invoice, this.direccionId, this.year)
    .then(result=>{
      if(result.status===200){
        var file = new Blob([result.data], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        var anchor = document.createElement("a");
        anchor.download = filename;
        anchor.href = fileURL;
        anchor.click();
      }
      else{
        this.infoTarifaPulsado(invoice);
      }
    });
  }

  limpiarMensajes(){
    this.listadoFacturas.forEach(element => {
      element.visible = false;
  });
  }

  infoTarifaPulsado(factura) {
    this.listadoFacturas.forEach(element => {
      if( element.id === factura ){
        element.visible = !element.visible;
      }
      else{
        element.visible = false;
      }
  });

}


  getYearDescription(year) {
    if (year === "" + new Date().getFullYear()) {
      return 'Último año';
    }
    return year;
  }

  formatStringDate(date) {
    if (!date) {
      return "--";
    }
    return this.$filter('date')(date, 'dd MMMM yyyy');
  }

  formatSlashDate(date) {
    if (!date) {
      return "--";
    }
    return this.$filter('date')(date, 'dd/MM/yyyy');
  }

  modalidadEstado(tipoFactura,facturaRectificativa,facturaBillingPaid, elemento ){
    if(facturaRectificativa!==null&&tipoFactura!==null&&tipoFactura==="A"){
      elemento.billingPaid="Abonada";
      return this.literalesEstados["Abonada"];
    }
    else{
      elemento.billingPaid=facturaBillingPaid;
      return this.literalesEstados[facturaBillingPaid];
    }
  }

  valorAbsoluto(elemento,valor){
    if(valor<0){elemento.consumption=Math.abs(valor);}
    return Math.abs(valor);
  }

  cambiaOrden(columna){
    this.reverse = (this.propertyName === columna) ? !this.reverse : false;
    this.propertyName = columna;
  }

}

historicoFacturasController.$inject = ["historicoFacturasService", "$filter", "$window", "$document"];

export { historicoFacturasController as HISTORICO_FACTURAS_CONTROLLER };
